// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"10d1c02b","578":"4516c9b0","871":"ef7c9166"}[chunkId] + ".chunk.js";
};